/**
 * Checks if the current theme is "SUPER_CARTEIRA"
 *
 * @example isSuperCarteiraTheme() // returns true if the theme is "SUPER_CARTEIRA"
 * @returns boolean
 */
export const isSuperCarteiraTheme = (): boolean => {
  return process.env.REACT_APP_THEME === "SUPER_CARTEIRA";
};
